module.exports = __webpack_public_path__ + "static/img/map3.8f57cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map3.png
// module id = y+Dy
// module chunks = 1